import { GenderEnum } from '@utmb/types/enum/GenderEnum';
import { SexEnum } from '@utmb/types/enum/SexEnum';

/**
 * Get the Gender depending of the parameter passed.
 *
 * If the parameter is of type `SexEnum`, the gender will be returned.
 *
 * and will be translated with next
 *
 * @param {string | SexEnum} gender
 *
 * @returns {string}
 */
export const getGender = (gender: string | SexEnum | GenderEnum): string => {
    return gender === SexEnum.MEN || gender == GenderEnum.MALE ? 'common.gender.men' : 'common.gender.women';
};
